export default "<p-confirmDialog header=\"İşlem Onayı\" icon=\"pi pi-exclamation-triangle\"></p-confirmDialog>\n<router-outlet></router-outlet>\n";